import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/wishlist/page.tsx");
